<footer>
  Spectro 2026 All Rights Reserved | v.1.3
</footer>
